import { UserGroupView, UserOverview } from "api/generated/model";
import {
    UserOrUserGroupOverview,
    mapUserOrUserGroupOverview,
} from "utils/user";

type UserOrUserGroupOverviewEnum =
    | { type: "User"; user: UserOverview }
    | { type: "UserGroup"; userGroup: UserGroupView };

function toUserOrUserGroupOverviewEnum(
    userOrGroup: UserOrUserGroupOverview
): UserOrUserGroupOverviewEnum {
    return mapUserOrUserGroupOverview<UserOrUserGroupOverviewEnum>(
        userOrGroup,
        (user) => ({ type: "User", user }),
        (userGroup) => ({ type: "UserGroup", userGroup })
    );
}

export { toUserOrUserGroupOverviewEnum };
export type { UserOrUserGroupOverviewEnum };
